module.exports = __webpack_public_path__ + "img/gb5782.prt.bd391bfb.jpg";